<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <layout :titlePage="'Configurando seu site'">
    <div class="onboarding-create-site">
      <welcome />
    </div>
  </layout>
</template>

<script>
import verifyOnboardingCompleteMixin from '@/mixins/verifyOnboardingCompleteMixin'
import layout from '@/layouts/Default.vue'
import welcome from '@/components/OnboardingCreationSite/Welcome.vue'

export default {
  mixins: [verifyOnboardingCompleteMixin],

  data() {
    return {
      mySiteInfo: {},
    }
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },

    answerUser: {
      get() {
        return this.$store.state.onboardingCreateSite.answersOfStep
      },
      set(payload) {
        this.$store.dispatch('setAnswer', payload)
      },
    },

    dataWedding: {
      get() {
        return this.$store.state.onboardingCreateSite.data_wedding
      },
      set(payload) {
        this.$store.dispatch('dataWed', payload)
      },
    },
  },

  components: {
    layout,
    welcome,
  },

  watch: {
    wedSiteInfo(info) {
      if (info) {
        this.start()
      }
    },
  },

  methods: {
    start() {
      this.mySiteInfo = this.wedSiteInfo

      if (this.mySiteInfo) {
        this.dataWedding = this.mySiteInfo

        if (!this.mySiteInfo.onboarding_concluido) {
          const result = this.mySiteInfo.site_url.split('/')

          this.answerUser.wed_id = parseInt(
            this.logonToken.token_payload.wed_id
          )

          let dataLocalStorageTemp = {}

          // set on localStorage
          let dataLocalStorage = JSON.parse(
            localStorage.getItem(`onboarding_wed${this.answerUser.wed_id}`)
          )

          if (!dataLocalStorage) {
            dataLocalStorageTemp = { onboarding_concluido: true }
          }

          localStorage.setItem(
            `onboarding_wed${this.logonToken.token_payload.wed_id}`,
            JSON.stringify(dataLocalStorageTemp)
          )
          // end

          this.answerUser.step8 = result[3]
        } else {
          this.redirectHomeSite()
        }
      }
    },

    redirectHomeSite() {
      //redirect to last step onboarding
      this.$router.push({ path: '/onboarding/passo-11' })
    },
  },

  metaInfo: {
    title: 'Configurando seu site',
  },
}
</script>

<style lang="scss">
#id,
.layout {
  height: 100%;

  @media (max-width: $mobile) {
    padding-bottom: 0;
  }
}
.onboarding-create-site {
  margin-top: 0px;

  &__img {
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    padding: 0;
    border-top-right-radius: 130px;
    border-bottom-right-radius: 130px;
    overflow: hidden;
    min-height: inherit;
    height: auto;
  }

  &__description {
    height: 100%;
    padding: 25px 15px 20px 23px;
    min-height: calc(100vh - 68px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 0px;

    @media (min-width: $tablet) {
      padding: 30px;
      height: auto;
    }

    &--width-80 {
      display: flex;
      flex-direction: column;
      justify-content: center;

      @media (min-width: $desktop) {
        max-width: 80%;
        margin: 0 auto;
      }
    }
  }

  &__emotion {
    font-size: 32px;
    margin-bottom: 30px;

    @media (min-width: $tablet) {
      font-size: 45px;
    }
  }

  &__title {
    color: $gray-7;
    font-size: 24px;
    margin-bottom: 20px;

    @media (min-width: $tablet) {
      font-size: 32px;
      margin-bottom: 8px;
    }
  }

  &__subtitle {
    color: $gray-7;
    font-size: 18px;
    max-width: 675px;
    margin: 0 auto;
    margin-bottom: 24px;
    line-height: 32px;

    @media (min-width: $tablet) {
      font-size: 24px;
    }
  }

  &__paragraph {
    margin-bottom: 20px;
    color: $gray-7;
  }
}
</style>
